import React, { useEffect, useRef } from 'react';
import { installBookaletTracking } from '../utils/bookingTracking';

const BookaletBookingPage = () => {
  const widgetContainerRef = useRef(null);

  useEffect(() => {
    installBookaletTracking(); // before the widget loads, so Bookalet finds the callbacks
    // Ensure the container is empty and the script hasn't been added yet
    if (widgetContainerRef.current && widgetContainerRef.current.innerHTML === '') {
      const script = document.createElement('script');
      script.src = "https://widgets.bookalet.co.uk/publish.js";
      script.setAttribute('data-bookalet', '9d118833-5b3d-46b8-a841-d7fb5b42f03e');
      script.setAttribute('data-property', '52372');
      script.setAttribute('data-theme', '24120');
      script.async = true;

      widgetContainerRef.current.appendChild(script);
    }

    // No cleanup function needed as Bookalet script handles its own state
  }, []); // The empty dependency array ensures this effect runs only once on mount

  return (
    <div>
      <h2>Book Online</h2>
      <ul style={{ marginTop: '1.5rem', marginBottom: '1.5rem' }}>
        <li>Best price when you book direct with us.</li>
        <li>Up to 2 dogs are welcome at £20 per dog per stay; please add the number of dogs as you check out.</li>
        <li>Changeover day is Friday and we mostly book week-long stays. Off-peak (November to mid December, and January to March outside half term) we also offer short breaks, Friday to Monday or Monday to Friday, for £650. Short breaks are available when you book direct.</li>
        <li>If you'd like to book a stay outside of what's available on our booking engine, please <a href="mailto:figtree@dhowell.net">contact us</a>.</li>
        <li>If you'd rather book via a travel agent, you can also find us on
              {' '}
              <a
                href="https://www.airbnb.co.uk/rooms/1477553045729011459"
                target="_blank"
                rel="noopener noreferrer"
              >
                AirBnB
              </a>
              {' '}(week-long stays only).
        </li>
      </ul>
      <div ref={widgetContainerRef}>
        {/* The Bookalet widget will be loaded here by the script */}
      </div>
    </div>
  );
};

export default BookaletBookingPage;
